import * as signalR from "@microsoft/signalr";

const connections = new Map<string, signalR.HubConnection>();
const readyPromises = new Map<string, Promise<signalR.HubConnection>>();

export function hubConnectionManager(url: string) {

  function getConnection() {
    if (!connections.has(url)) {
      const connection = new signalR.HubConnectionBuilder()
        .withUrl(url)
        .withAutomaticReconnect()
        .build();

      connection.onclose(() => {
        readyPromises.delete(url);
      });

      connections.set(url, connection);
    }

    return connections.get(url)!;
  }

  async function start(): Promise<signalR.HubConnection> {
    if (!readyPromises.has(url)) {
      readyPromises.set(
        url,
        (async () => {
          const conn = getConnection();
          await conn.start();
          return conn;
        })().catch(err => {
          readyPromises.delete(url);
          throw err;
        })
      );
    }

    return readyPromises.get(url)!;
  }

  function isStarted(): boolean {
    return readyPromises.has(url);
  }

  async function stop() {
    const conn = connections.get(url);

    if (conn) {
      await conn.stop();
      connections.delete(url);
      readyPromises.delete(url);
    }
  }

  async function invoke<T = any>(method: string, ...args: any[]): Promise<T | null> {
    try {
      const connection = await start();
      return await connection.invoke(method, ...args);
    } catch (e) {
      console.error(e);
      return null;
    }
  }

  return {
    start,
    invoke,
    stop,
    isStarted
  };
}
